import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";

const PHONE_DISPLAY = "+91 90911 00200";
const PHONE_TEL = "+919091100200";

const links = [
  { label: "Destinations", id: "destinations" },
  { label: "Itineraries", id: "itineraries" },
  { label: "Visa Services", id: "visa" },
  { label: "Villas", id: "villas" },
  { label: "Why Us", id: "stats" },
  { label: "Contact", id: "contact" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${scrolled ? "py-2.5" : "py-4"}`}
    >
      <nav
        className={`mx-auto max-w-7xl px-4 md:px-6 flex items-center justify-between transition-all duration-500 ${
          scrolled ? "glass rounded-2xl mx-3 md:mx-6 py-2 px-4 md:px-5" : "py-1"
        }`}
      >
        <button
          data-testid="brand-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2 group shrink-0"
          aria-label="Travel Factor home"
        >
          <img
            src="/travel-factor-logo.png"
            alt="Travel Factor"
            className="h-14 md:h-16 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.03]"
            draggable="false"
          />
        </button>

        <div className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="link-underline text-sm text-navy-deep/85 hover:text-navy-deep transition-colors font-medium"
            >
              {l.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-2 md:gap-3">
          <a
            href={`tel:${PHONE_TEL}`}
            data-testid="nav-phone"
            className="hidden md:inline-flex items-center gap-2 px-3.5 py-2 rounded-full text-sm font-semibold text-navy-deep hover:text-navy hover:bg-sky-soft/60 transition-colors"
          >
            <Phone className="w-3.5 h-3.5 text-sky-brand" strokeWidth={2.5} />
            {PHONE_DISPLAY}
          </a>
          <button
            data-testid="nav-cta-apply"
            onClick={() => scrollTo("contact")}
            className="hidden sm:inline-flex items-center gap-2 px-5 py-2.5 rounded-full gradient-navy text-white font-semibold text-sm shadow-[0_8px_24px_-8px_rgba(0,51,102,0.4)] hover:shadow-[0_12px_32px_-8px_rgba(0,51,102,0.55)] transition-all hover:scale-[1.03]"
          >
            Apply For Visa
          </button>
          <button
            data-testid="nav-menu-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden w-10 h-10 rounded-full glass flex items-center justify-center text-navy-deep"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden mx-3 mt-3 glass rounded-2xl p-4 flex flex-col gap-1.5">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              className="text-left py-2.5 px-3 text-navy-deep hover:bg-sky-soft/60 rounded-lg font-medium text-sm"
            >
              {l.label}
            </button>
          ))}
          <a
            href={`tel:${PHONE_TEL}`}
            className="flex items-center gap-2 py-2.5 px-3 text-navy rounded-lg font-semibold text-sm border-t border-navy/10 mt-2"
            data-testid="mobile-nav-phone"
          >
            <Phone className="w-4 h-4 text-sky-brand" strokeWidth={2.5} />
            {PHONE_DISPLAY}
          </a>
          <button
            onClick={() => scrollTo("contact")}
            className="mt-1 w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full gradient-navy text-white font-semibold text-sm"
          >
            Apply For Visa
          </button>
        </div>
      )}
    </header>
  );
}
